import { createSlice } from '@reduxjs/toolkit';
import { catalogCreateProjectType } from './catalogAsyncThunk';

const catalogCreateProjectTypeSlice = createSlice({
  name: "catalog",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [catalogCreateProjectType.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [catalogCreateProjectType.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [catalogCreateProjectType.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default catalogCreateProjectTypeSlice.reducer;